import React from 'react'
import { graphql } from 'gatsby'
import { useIntl } from 'gatsby-plugin-intl'

import Layout from 'components/layout'
import MetaTags from 'components/MetaTags'
import Section, { SectionBlock } from 'components/Section'
import Wrapper from 'components/Wrapper'
import Header from 'components/Header'
import GridRow from 'components/grid/GridRow'
import GridItem from 'components/grid/GridItem'
import policiesBody from 'content/policiesBody.json'
import { policiesHeaderByLocale } from 'content/marketingPages'

const Policies = ({ data }) => {
  const intl = useIntl()
  const header = policiesHeaderByLocale[intl.locale]
  const paragraphs = policiesBody[intl.locale]
  const {
    headerImage: {
      childImageSharp: { fluid },
    },
  } = data

  return (
    <Layout>
      <MetaTags
        title={`${intl.formatMessage({ id: 'policies' })} | Hotel Griffintown`}
      />
      <Header
        eyebrow={header.eyebrow[0].text}
        heading={header.heading[0].text}
        fluid={fluid}
      />
      <Section>
        <Wrapper size='narrow'>
          <SectionBlock>
            <GridRow>
              <GridItem xs='1-1' lg='3-4'>
                {paragraphs.map((text, i) => (
                  <p key={i}>{text}</p>
                ))}
              </GridItem>
            </GridRow>
          </SectionBlock>
        </Wrapper>
      </Section>
    </Layout>
  )
}

export const query = graphql`
  query PoliciesPage {
    headerImage: file(name: { eq: "img-hero-policies" }) {
      childImageSharp {
        fluid(maxWidth: 2560, quality: 100, cropFocus: CENTER) {
          ...GatsbyImageSharpFluid
        }
      }
    }
  }
`

export default Policies
